/* eslint-disable  */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

const Field = ({ label, required, error, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">
      {label}{required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

const inputCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent";
const readonlyCls = "mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed";
const selectCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500";

function PersonalInfo() {
  const dispatch = useDispatch();
  const history = useHistory();
  const signatureRef = useRef({});

  const {
    SubmitLoanFormOne,
    SubmitUpdateLoanFormOne,
    ResetUserDataResponse,
    GetFormOneAppliedLoanTemp,
    CancelLoanApplicationTemp,
    GetAppliedLoans,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(1);
  const [formData, setFormData] = useState({});
  const [age, setAge] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [formError, setFormError] = useState({});

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const auth = useSelector((state) => state?.auth);
  const user = auth?.user;
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    GetFormOneAppliedLoanTemp();
    GetAppliedLoans();
  }, []);

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
  };

  const handleDoBChange = (e) => {
    const year = new Date().getFullYear();
    const dob = e?.target?.value?.split("-")[0];
    setAge(parseInt(year) - parseInt(dob));
    setDateOfBirth(e?.target?.value);
  };

  let gender = "";
  const prefix = user?.name?.split(" ")[0];
  if (prefix === "Mr.") gender = "Male";
  else if (["Miss", "Miss.", "Ms.", "Mrs."].includes(prefix)) gender = "Female";
  else gender = null;

  const employer_name = user?.facility?.split(" ")[1]?.split(":")[0];

  const setFormFromUser = (loanTempData, userData) => {
    const year = new Date().getFullYear();
    const dob = userData?.dob?.split("-")[0];
    const newAge = parseInt(year) - parseInt(dob);
    setFormData({
      ...formData,
      staff_id: userData?.staff_id,
      facility: userData?.facility,
      email: userData?.email || loanTempData?.email,
      gender: loanTempData?.gender || gender,
      fullname: userData?.name,
      IdCardType: "Ghana National Identification",
      employer_name,
      dateOfBirth: userData?.dob || loanTempData?.dateOfBirth,
      age: newAge || loanTempData?.age,
      sector: loanTempData?.sector,
      IDCardNumber: loanTempData?.IDCardNumber,
      personal_phone: userData?.phone_number || loanTempData?.personal_phone,
      residential_address1: loanTempData?.residential_address1,
      residential_address2: loanTempData?.residential_address2,
      ssnit: loanTempData?.ssnit,
      work_address1: loanTempData?.work_address1,
      work_address2: loanTempData?.work_address2,
      work_phone: loanTempData?.work_phone,
    });
    setDateOfBirth(userData?.dob || loanTempData?.dateOfBirth);
    setAge(newAge || loanTempData?.age);
  };

  useEffect(() => {
    GetUserProfile();
    setFormFromUser(loanTemp, user);
  }, []);

  useEffect(() => {
    setFormFromUser(loanTemp, user);
  }, [loanTemp, user]);

  const validateForm = () => {
    let err = {};
    if (!formData.sector) err.sector = "Please select your region";
    if (!formData.ssnit) err.ssnit = "SSNIT is required";
    if (!dateOfBirth) err.dateOfBirth = "Date of birth is required";
    if (!formData.IDCardNumber) err.IDCardNumber = "Ghana identification number required";
    if (!formData.residential_address1) err.residential_address1 = "Residential address is required";
    if (!formData.work_address1) err.work_address1 = "Work address is required";
    if (!formData.personal_phone) err.personal_phone = "Phone number is required";
    if (!formData.work_phone) err.work_phone = "Work phone is required";
    if (!formData.gender) err.gender = "Gender is required";
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleSubmitFormOne = () => {
    if (!validateForm()) return;
    const payload = {
      ...formData,
      age,
      gender: formData.gender,
      dateOfBirth,
      sector: formData.sector?.split(":")[0],
      region: formData.sector?.split(":")[1],
      staff_id: user?.staff_id,
    };
    if (!loanTemp) {
      SubmitLoanFormOne(payload);
    } else {
      SubmitUpdateLoanFormOne(
        { ...loanTemp, ...formData, age, gender: formData.gender, dateOfBirth, sector: formData.sector?.split(":")[0], region: formData.sector?.split(":")[1] },
        loanTemp?._id
      );
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      ResetUserDataResponse();
      history.push("/apply-loan-guarantor");
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan" >
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <form onSubmit={(e) => e.preventDefault()} style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          {/* Personal Information */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Personal Information</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <Field label="Full Name">
                <input
                  type="text"
                  name="fullname"
                  readOnly
                  value={formData.fullname ?? ""}
                  className={readonlyCls}
                />
              </Field>
              <Field label="Choose Your Region" required error={formError.sector}>
                <select
                  name="sector"
                  value={formData.sector ?? ""}
                  onChange={handleFormChange}
                  className={selectCls}
                >
                  <option value="" disabled>-- Select your region --</option>
                  <option value="Southern:Greater Accra">Greater Accra</option>
                  <option value="Southern:Eastern">Eastern</option>
                  <option value="Southern:Central">Central</option>
                  <option value="Southern:Bono">Bono</option>
                  <option value="Southern:Bono East">Bono East</option>
                  <option value="Southern:Ashanti">Ashanti</option>
                  <option value="Southern:Ahafo">Ahafo</option>
                  <option value="Northern:Western">Western</option>
                  <option value="Northern:Western North">Western North</option>
                  <option value="Northern:Volta">Volta</option>
                  <option value="Northern:Upper West">Upper West</option>
                  <option value="Northern:Upper East">Upper East</option>
                  <option value="Northern:Savannah">Savannah</option>
                  <option value="Northern:Oti">Oti</option>
                  <option value="Northern:Northern">Northern</option>
                  <option value="Northern:North East">North East</option>
                </select>
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Date of Birth" required error={formError.dateOfBirth}>
                <input
                  type="date"
                  name="dateOfBirth"
                  readOnly
                  value={formData.dateOfBirth ?? ""}
                  className={readonlyCls}
                />
              </Field>
              <Field label="Age">
                <input
                  type="text"
                  name="age"
                  readOnly
                  value={age || ""}
                  className={readonlyCls}
                  placeholder="Calculated from DOB"
                />
              </Field>
              <Field label="SSNIT" required error={formError.ssnit}>
                <input
                  type="text"
                  name="ssnit"
                  value={formData.ssnit ?? ""}
                  placeholder="Enter your SSNIT number"
                  onChange={handleFormChange}
                  className={inputCls}
                />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="ID Type" required>
                <select
                  name="IdCardType"
                  value="Ghana National Identification"
                  onChange={handleFormChange}
                  className={selectCls}
                >
                  <option value="Ghana National Identification">Ghana National Identification</option>
                </select>
              </Field>
              <Field label="ID Number" required error={formError.IDCardNumber}>
                <input
                  type="text"
                  name="IDCardNumber"
                  value={formData.IDCardNumber ?? ""}
                  placeholder="Enter your Ghana Card number"
                  onChange={handleFormChange}
                  className={inputCls}
                />
              </Field>
              <Field label="Gender" required error={formError.gender}>
                <select
                  name="gender"
                  value={formData.gender ?? ""}
                  onChange={handleFormChange}
                  className={selectCls}
                >
                  <option value="" disabled>-- Select gender --</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Field label="Residential Address" required error={formError.residential_address1}>
                <input
                  type="text"
                  name="residential_address1"
                  value={formData.residential_address1 ?? ""}
                  placeholder="Address line 1"
                  onChange={handleFormChange}
                  className={inputCls}
                />
                <input
                  type="text"
                  name="residential_address2"
                  value={formData.residential_address2 ?? ""}
                  placeholder="Address line 2 (optional)"
                  onChange={handleFormChange}
                  className={`${inputCls} mt-2`}
                />
              </Field>
              <Field label="Work Address" required error={formError.work_address1}>
                <input
                  type="text"
                  name="work_address1"
                  value={formData.work_address1 ?? ""}
                  placeholder="Work address line 1"
                  onChange={handleFormChange}
                  className={inputCls}
                />
                <input
                  type="text"
                  name="work_address2"
                  value={formData.work_address2 ?? ""}
                  placeholder="Address line 2 (optional)"
                  onChange={handleFormChange}
                  className={`${inputCls} mt-2`}
                />
              </Field>
            </div>
          </div>

          {/* Contact Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Contact Details</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <Field label="Phone Number" required error={formError.personal_phone}>
                <input
                  type="text"
                  name="personal_phone"
                  value={formData.personal_phone ?? ""}
                  placeholder="Enter your phone number"
                  onChange={handleFormChange}
                  className={inputCls}
                />
              </Field>
              <Field label="Work Phone" required error={formError.work_phone}>
                <input
                  type="text"
                  name="work_phone"
                  value={formData.work_phone ?? ""}
                  placeholder="Enter your work phone number"
                  onChange={handleFormChange}
                  className={inputCls}
                />
              </Field>
            </div>

            <Field label="Email Address">
              <input
                type="email"
                name="email"
                value={formData.email ?? ""}
                readOnly
                className={readonlyCls}
              />
            </Field>
          </div>

          {/* Action */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={handleSubmitFormOne}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none"
            >
              Save and continue
            </button>
          </div>

        </form>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default PersonalInfo;
